<template>
  <div>
    <div style="font-size:22px; margin-bottom:20px; text-align:center;">
      {{source.name}} - Manual Entry
    </div>
    <div class="reference-form" ref="referenceForm">
      <div v-if="source && referenceMetadata" class="fields">
        <div v-for="(field, index) in source.fields" :key="index" >
          <transition name="fade">
            <div v-if="field.type === 'name'" class="field names">
              <transition-group name="fade-forward">
                <ReferenceFormName v-for="name in referenceMetadata[field.id]" :key="name" :label="field.label" :name="name" @onDelete="referenceMetadata[field.id].splice(referenceMetadata[field.id].indexOf(name), 1)"></ReferenceFormName>
              </transition-group>
              <button class="add-name-btn blue" @click="referenceMetadata[field.id].push({})">
                <span>
                  <i class="material-icons">add_circle_outline</i>Add another person
                </span>
              </button>
            </div>
            <div v-if="field.type === 'string'" class="field string">
              <label>{{field.label}}</label>
              <div class="input">
                <input type="text" :placeholder="field.placeholder" :name="field.id" v-model="referenceMetadata[field.id]" />
              </div>
            </div>
            <div v-if="field.type === 'text'" class="field text">
              <label>{{field.label}}</label>
              <div class="input">
                <textarea :placeholder="field.placeholder" :name="field.id" v-model="referenceMetadata[field.id]" :class="{'important': field.isImportant && !referenceMetadata[field.id]}"></textarea>
              </div>
            </div>
            <div v-if="field.type === 'date'" class="field date">
              <label>{{field.label}}</label>
              <div class="input">
                <input type="number" placeholder="YYYY" v-model="referenceMetadata[field.id].year" />
                <input type="number" placeholder="MM" v-model="referenceMetadata[field.id].month" />
                <input type="number" placeholder="DD" v-model="referenceMetadata[field.id].day" />
                <button @click="setDateToToday(referenceMetadata[field.id])" class="date__today-btn">today</button>
              </div>
            </div>
          </transition>
        </div>
      </div>
    </div>

    <TooltipLg tooltipId="newReferenceForm" category="intro" placement="left start" :target="referenceFormTooltipTarget" primary>
      <p>👀 Add as many details as you can for the source.</p>
      <p>If you can't find all of them don't worry - we'll still create the reference accurately.</p>
      <p>When you've done as much as you can, click the Generate button to generate your reference.</p>
    </TooltipLg>
  </div>
</template>

<script>
import Config from '@/config.js';

import ReferenceFormName from '@/components/ReferenceFormName';
import TooltipLg from '@/components/TooltipLg';

export default {
  name: 'ReferenceForm',
  props: ['referenceMetadata'],
  components: {
    ReferenceFormName,
    TooltipLg
  },
  data () {
    return {
      config: Config,
      sourcesMenuIsOpen: false,
      sourcesMenuTrigger: null,
      referenceFormTooltipTarget: null
    };
  },
  computed: {
    source () {
      return this.config.sources.find((s) => {
        return s.id === this.$route.params.sourceId;
      });
    }
  },
  methods: {
    toggleSourcesMenu () {
      this.sourcesMenuIsOpen = !this.sourcesMenuIsOpen
    },
    handleSourcesMenuClose () {
      this.sourcesMenuIsOpen = false;
    },
    setDateToToday (field) {
      const dt = new Date();
      field.day = dt.getDate();
      field.month = dt.getMonth() + 1;
      field.year = dt.getFullYear();
      this.$forceUpdate();
    }
  },
  created () {
    // if any of the name fields have no authors, add blank ones so the inputs appear
  },
  mounted () {
    this.sourcesMenuTrigger = this.$refs.sourcesMenuBtn;
    this.referenceFormTooltipTarget = this.$refs.referenceForm;
  }
}
</script>

<style lang="scss">
@import '../variables.scss';

.mb-widget {
  .reference-form {
    .fields {
      .field { margin-bottom:20px;
        label { align-items:center; font-size:14px; font-weight:700; padding-right:18px; text-transform:uppercase; width:150px; }
        .input { display:flex; position:relative; width:100%; }
        input[type=text], input[type=number] { border:1px solid #d7dbe0; border-radius:3px; font-size:14px; max-height:35px; padding:12px 12px; }
        textarea { border:1px solid #d7dbe0; border-radius:3px; font-size:14px; min-height:100px; padding:12px 12px; width:100%; }

        &.names { display: block; position:relative;
          .add-name-btn {
            i { margin-right:4px; }
          }
        }
        &.string {
          input { width:100%; }
        }
        &.date {
          input { width:27%; }
          .date__today-btn { color:$secondary-color; font-size:13px; text-transform:uppercase; width: 19%; }
        }
      }
    }
    .more-fields { color:#959eba; font-size:12px; margin-bottom:20px; text-align:right; text-transform:uppercase; }
  }

  @media screen and (min-width: 60em) {
    .reference-form { margin:auto; width:460px;
      .fields {
        .field { display:flex;
          label { display:flex; justify-content:flex-end; text-align:right; }
          .input { width:310px; }

          &.names {
            .add-name-btn { margin-left:154px; }
          }
          &.date {
            input { width:33.3%; }
            .date__today-btn { left:100%; margin-left:4px; position:absolute; top:7px; }
          }
        }
      }
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/ReferenceForm.vue